import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { updateSelectVariable } from "../../../../../store/reducers/pdfeditor/toolsModificationSlice";
import { updateCoordinate } from "../../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";

const FontSpacing = () => {
  const dispatch = useDispatch();
  const { fontSpace, currVariable } = useSelector(
    (state) => state.toolsModification
  );
  // const { currVariable } = useSelector((state) => state.toolsModification);

  const handleChangeFontSpace = (e) => {
    let value = Number(e.target.value);
    let data = { fontSpace: value };
    if (value >= 1 && value <= 25 && !currVariable?.variable) {
      dispatch(updateSelectVariable(data));
    } else if (value >= 1 && value <= 25) {
      dispatch(updateSelectVariable(data));
      dispatch(
        updateCoordinate({ id: currVariable?.variable, newValue: data })
      );
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
      let newValue = parseInt(fontSpace);
      if (e.key === "ArrowUp") {
        newValue = Math.min(newValue + 1, 25);
      } else if (e.key === "ArrowDown") {
        newValue = Math.max(newValue - 1, 1);
      }

      let data = { fontSpace: newValue };
      if (!currVariable?.variable) {
        dispatch(updateSelectVariable(data));
      } else {
        dispatch(updateSelectVariable(data));
        dispatch(
          updateCoordinate({ id: currVariable?.variable, newValue: data })
        );
      }
    }
  };

  return (
    <Wrapper>
      <input
        type='number'
        value={currVariable?.fontSpace}
        onChange={handleChangeFontSpace}
        style={inputStyle}
        // disabled={currVariable?.data_type === "image"}
        onKeyDown={handleKeyPress}
      />
    </Wrapper>
  );
};

export default FontSpacing;
const inputStyle = {
  width: "100%",
  height: "25px",
};
const Wrapper = styled.div`
  .size-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 22%;
  }
  p {
    font-size: 12px;
    margin-right: 5px;
    white-space: nowrap;
  }
`;


